import React from "react";
import { connect } from "react-redux";

// Components
import Searchbar from "../../utils/searchbar/Searchbar";
import SearchTrainingSurveys from "./SearchTrainingSurveys";

// State
import { addRoute } from "../../../store/actions/route";

class AdminTrainingSurveys extends React.Component {
	constructor(props) {
		super(props);

		this.props.addRoute(this.props.match);
	}

	render() {
		return (
			<React.Fragment>
				<Searchbar
					placeholder={"Search training surveys"}
					component={SearchTrainingSurveys}
					searchEndpoint={"search/training-surveys"}
					basePath={null}
					userType="admin"
				/>
			</React.Fragment>
		);
	}
}

export default connect(
	null,
	{ addRoute }
)(AdminTrainingSurveys);



// WEBPACK FOOTER //
// ./src/components/admin/training-surveys/AdminTrainingSurveys.js